import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";

function UpdateVoice(props) {
    const navigate = useHistory();
    const [formData, setName] = useState({
        VoiceName: "",
        VoiceId: "",
    });
    const VoiceId = localStorage.getItem("VoiceId");
    const LoadVoice = () => {
        const dataValue = {
            id: VoiceId,
        };
        const authOptions = {
            method: "post",
            url: `${process.env.REACT_APP_API_URL}/getVoiceById`,
            data: dataValue,
            headers: { "Content-Type": "multipart/form-data" },
        };
        axios(authOptions)
            .then((res) => {
                setName({
                    VoiceName: res.data.voice_Name,
                    VoiceId: res.data.voice_Id,
                });
            });
    };
    useEffect(() => {
        LoadVoice();
    }, []);
    const Update = async (e) => {
        e.preventDefault();
        let formDataSet = new FormData();
        if (formData.VoiceName === "" || formData.VoiceId === "") {
            if (formData.VoiceName === "") {
                await Swal.fire({
                    title: "Error",
                    text: "Voice name is required.",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
            if (formData.VoiceId === "") {
                await Swal.fire({
                    title: "Error",
                    text: "Voice id is required.",
                    icon: "error",
                    confirmButtonText: "Ok",
                });
            }
        } else {
            formDataSet.append("Id", VoiceId);
            formDataSet.append("Voice_Name", formData.VoiceName);
            formDataSet.append("Voice_Id", formData.VoiceId);
            // Extract token from localStorage.state
            let token = null;
            try {
                const raw = localStorage.getItem("state");
                if (raw) {
                    const state = JSON.parse(raw);
                    token = state.auth?.token;
                }
            } catch (e) {
                console.error("Token parsing failed", e);
            }
            const authOptions = {
                method: "post",
                url: `${process.env.REACT_APP_API_URL}/UpdateVoice`,
                data: formDataSet,
                headers: { "content-type": "multipart/form-data", ...(token && { "Authorization": `Bearer ${token}` }) },
            };
            axios(authOptions)
                .then((res) => {
                    if (res.data.ExpResult) {
                        Swal.fire({
                            title: "Failed",
                            text: res.data.ExpResult,
                            icon: "error",
                            confirmButtonText: "Ok",
                        });
                    } else if (res.data.SuccessResult) {
                        Swal.fire({
                            title: "Success",
                            text: res.data.SuccessResult,
                            icon: "success",
                            confirmButtonText: "Ok",
                        }).then(function () {
                            navigate.push("/VoiceList")
                        });
                    } else {
                        Swal.fire({
                            title: "Error",
                            text: "An error occurred!",
                            icon: "error",
                            confirmButtonText: "Ok",
                        });
                    }
                })
                .catch((error) => {
                    Swal.fire({
                        title: "Error Occurred",
                        text: error,
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                });
        }
    };
    const handleChange = (e) => {
        setName({ ...formData, [e.target.name]: e.target.value });
    };
    /* Function to redirect in Voice List Page */
    const BackFunc = () => {
        navigate.push("/VoiceList")
    };
    return (
        <>
            <div className="page-content-wrapper">
                <div className="page-content">
                    <div className="page-bar">
                        <div className="page-title-breadcrumb">
                            <div className=" pull-left">
                                <div className="page-title my-0">Update Voice</div>
                            </div>
                            <div className=" pull-right">
                                <button
                                    type="submit"
                                    className="btn d-inline-block btn-primary"
                                    style={{ color: "#FFF", border: "1px solid #1e2b38" }}
                                    onClick={BackFunc}
                                >
                                    {" "}
                                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-2 col-sm-2"></div>
                        <div className="col-md-8 col-sm-8">
                            <div className="card card-box">
                                <div className="card-head">
                                    <header>Update Voice</header>
                                </div>
                                <div className="card-body " id="bar-parent1">
                                    <form
                                        className="register-form"
                                        id="login-form"
                                        onSubmit={Update}
                                    >
                                        {/* Voice Name */}
                                        <div className="form-group row required">
                                            <label
                                                htmlFor="voiceName"
                                                className="col-sm-3 control-label"
                                            >
                                                {" "}
                                                Voice Name
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    value={formData.VoiceName}
                                                    onChange={handleChange}
                                                    name="VoiceName"
                                                    className="form-control"
                                                    id="VoiceName"
                                                    placeholder="Voice Name"
                                                />
                                            </div>
                                        </div>
                                        {/* Voice ID */}
                                        <div className="form-group row required">
                                            <label
                                                htmlFor="VoiceId"
                                                className="col-sm-3 control-label"
                                            >
                                                {" "}
                                                Voice Id
                                            </label>
                                            <div className="col-sm-9">
                                                <input
                                                    type="text"
                                                    value={formData.VoiceId}
                                                    onChange={handleChange}
                                                    name="VoiceId"
                                                    className="form-control"
                                                    id="VoiceId"
                                                    placeholder="Voice Id"
                                                />
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 text-end">
                                                <button
                                                    type="submit"
                                                    className="btn d-inline-block btn-primary"
                                                    style={{
                                                        color: "#FFF",
                                                        border: "1px solid #1e2b38"
                                                    }}
                                                >
                                                    Update
                                                </button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-3 col-sm-3"></div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default UpdateVoice;